import {z} from 'zod';

import {isNotNil} from 'ramda';

import type {DataGridRow} from '@dms/api/core';

import {getSafely} from 'shared/web';

export const DATA_GRID_STRING_VALUE_SCHEMA = z.string();
export const DATA_GRID_STRING_ARRAY_VALUE_SCHEMA = z.array(z.string());
export const DATA_GRID_KEY_VALUE_SCHEMA = z.object({
  key: z.string(),
  label: z.string().nullable().optional(),
});
export const DATA_GRID_ENTITY_VALUE_SCHEMA = z.object({
  id: z.string(),
  label: z.string(),
  resourceId: z.string().nullable(),
});
export const DATA_GRID_MONEY_VALUE_SCHEMA = z.object({
  amount: z.union([z.number(), z.string()]),
  currency: z.string(),
});

export const readDataGridCell = (row: DataGridRow, keys: readonly string[]) =>
  keys.map((key) => getSafely(row.cells, key)?.value).find(isNotNil);
